<kno2-dialog-body>
    <p class="mb-4">
        Opening
        <strong>{{ organizationName() }}</strong>
        requires signing in again.
    </p>

    <div class="small text-uppercase text-muted mb-2">{{ choices().length > 1 ? "Choose how to sign in" : "Sign in with" }}</div>

    <div class="list-group mb-4">
        @for (choice of choices(); track $index) {
            <button
                type="button"
                class="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3"
                (click)="signIn(choice.option)">
                <i class="fa fa-fw fa-lg text-muted {{ choice.icon }}"></i>
                <span class="flex-grow-1 text-start">
                    <span class="d-block fw-bold">{{ choice.label }}</span>
                    <span class="d-block small text-muted">{{ choice.hint }}</span>
                </span>
                <i class="fa fa-chevron-right text-muted"></i>
            </button>
        }
    </div>

    <div class="d-flex gap-2 small text-muted">
        <i class="fa fa-info-circle mt-1"></i>
        <span>Use the sign-in you have for {{ organizationName() }}. It may be different from the one you used for your current organization.</span>
    </div>
</kno2-dialog-body>
<kno2-dialog-footer>
    <button
        type="button"
        class="btn btn-default"
        (click)="cancel()">
        Cancel
    </button>
</kno2-dialog-footer>
